/* tslint:disable */
type ChildStatus =
  'All' |
  'has_child' |
  'no_child';
module ChildStatus {
  export const ALL: ChildStatus = 'All';
  export const HAS_CHILD: ChildStatus = 'has_child';
  export const NO_CHILD: ChildStatus = 'no_child';
  export function values(): ChildStatus[] {
    return [
      ALL,
      HAS_CHILD,
      NO_CHILD
    ];
  }
}

export { ChildStatus }